import { createSlice } from '@reduxjs/toolkit';
import { ISsoClaims } from '../models/Login/ISsoClaims';

interface ssoState {
  ssoClaims: ISsoClaims;
  token: string;
  ssoUUId: string;
  authenticationerror: boolean;
}

const initialState: ssoState = {
  ssoClaims: null,
  token: '',
  ssoUUId: '',
  authenticationerror: false,
};

export const ssoUserSlice = createSlice({
  name: 'ssoUser',
  initialState,
  reducers: {
    saveSsoClaims: (state, action) => {
      state.ssoClaims = action.payload;
    },
    deleteSsoClaims: state => {
      state.ssoClaims = null;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    removeToken: state => {
      state.token = '';
    },
    setSsoUUId: (state, action) => {
      state.ssoUUId = action.payload;
    },
    setAuthenticationError: (state, action) => {
      state.authenticationerror = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  saveSsoClaims,
  deleteSsoClaims,
  setToken,
  removeToken,
  setSsoUUId,
  setAuthenticationError,
} = ssoUserSlice.actions;

export default ssoUserSlice.reducer;
